import { CONFIG } from '../data/config';
import { MA_HISTORY } from '../data/maHistory';
import RevenueChart from './growth/RevenueChart';

interface GrowthProps {
  gray?: boolean;
}

export default function Growth({ gray }: GrowthProps) {
  return (
    <section
      id="growth"
      className={'section ' + (gray ? 'section--gray' : 'section--paper')}
    >
      <div className="container">
        <div className="eyebrow">
          <span className="bar" />
          <span>Growth Trajectory</span>
        </div>

        <div className="growth-cap" style={{ marginTop: 28 }}>
          <div>
            <h2 className="h2">
              Compounding,
              <br />
              <span className="red">M&amp;A by M&amp;A</span>.
            </h2>
          </div>
          <p className="lede">
            Mystar Engineering has executed M&amp;A on {CONFIG.maDealsTotal} companies
            since {CONFIG.maDealsSince}. Group revenue has compounded across both
            manufacturing and critical-infrastructure segments.
          </p>
        </div>

        <div className="stat-cards">
          <div className="stat-card featured">
            <span className="lbl">Consolidated revenue</span>
            <span className="v">{CONFIG.revenue}</span>
            <span className="note">{CONFIG.revenueNote}</span>
          </div>
          <div className="stat-card">
            <span className="lbl">Group companies</span>
            <span className="v">
              {CONFIG.companies}
              <span className="unit">companies</span>
            </span>
            <span className="note">{CONFIG.companiesNote}</span>
          </div>
        </div>

        <div className="chart-wrap">
          <div className="chart-head">
            <div className="chart-title">ME Group consolidated revenue</div>
            <div className="chart-unit">Unit: ¥100M · FY ending March</div>
          </div>
          <RevenueChart />
          <div className="chart-legend">
            <span>
              <span className="sw sw-infra" />
              Critical Infrastructure
            </span>
            <span>
              <span className="sw sw-mecha" />
              Mechatronics
            </span>
            <span>
              <span className="sw sw-other" />
              Other
            </span>
          </div>
        </div>

        <div style={{ marginTop: 48 }}>
          <div className="eyebrow">
            <span className="dot" />
            <span>
              M&amp;A history · {CONFIG.maDealsTotal} deals since {CONFIG.maDealsSince}
            </span>
          </div>
          <div className="ma-history">
            {MA_HISTORY.map((m, i) => (
              <div className="ma-cell" key={i}>
                <div className="yr">
                  <b>{m.yr}</b>
                </div>
                <div className="ma-logos">
                  {m.companies.map((c, j) => (
                    <div className="ma-logo" key={j} title={c.name}>
                      <img src={c.logo} alt={c.name} loading="lazy" />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
